import React, { useEffect } from "react";
import { HashLink } from "react-router-hash-link";
import roof_inspection from "../assets/images/services/old-roof-inspection.avif";
import roof_repair from "../assets/images/services/roof-repair2.jpg";
import roof_replacement from "../assets/images/services/roof-replacement.jpeg";
import storm_damage from "../assets/images/services/storm-damage.png";
import ScrollReveal from "scrollreveal";

const features = [
  {
    name: "Roof Inspection",
    description:
      "Our thorough roof inspection identifies all storm-related and maintenance issues, ensuring your roof remains in peak condition. We assess for leaks, damaged shingles, and structural concerns to prevent costly future repairs.",
    imageSrc: roof_inspection,
    imageAlt: "Person inspecting a roof.",
  },
  {
    name: "Roof Repair",
    description:
      "We perform expert roof repairs using high-quality GAF or CertainTeed products, installed to manufacturer specifications for long-lasting durability and protection.",
    imageSrc: roof_repair,
    imageAlt: "Roof repair tools and materials.",
  },
  {
    name: "Roof Replacement",
    description:
      "When a full roof replacement is needed, we use GAF or CertainTeed products installed to exact manufacturer specifications. Thanks to our status, we can offer extended 25-year warranties through the manufacturer for added peace of mind.",
    imageSrc: roof_replacement,
    imageAlt: "Finished roof replacement with new materials.",
  },
  {
    name: "Storm Damage",
    description:
      "Storm damage is unavoidable in our coastal area. We are experts in identifying these damages and guiding you through the insurance process to ensure you get the coverage and repairs you need. Consider us your personal roofing attorney!",
    imageSrc: storm_damage,
    imageAlt: "Roof with storm damage.",
  },
];

export default function Example() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const sr = ScrollReveal({ reset: false });

      // header texts (label, title, intro) in sequence
      sr.reveal("#services .max-w-3xl > p", {
        origin: "left",
        distance: "30px",
        duration: 600,
        interval: 150,
      });

      // each feature card with a slight stagger
      sr.reveal(".reveal-card", {
        origin: "bottom",
        distance: "20px",
        duration: 700,
        interval: 200,
        delay: 300,
      });

      // the "View Additional Services" button
      sr.reveal("#services a", {
        origin: "bottom",
        distance: "10px",
        duration: 500,
        delay: 800,
      });
    }
  }, []);

  return (
    <div id="services" className="bg-white">
      <div className="mx-auto max-w-2xl px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:px-8">
        <div className="max-w-3xl">
          <p className="font-chakra_petch_sm text-base/7 font-semibold text-[#D2B48C]">
            ROOFING SERVICES WE PROVIDE
          </p>
          <p className="font-chakra_petch_lg mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            OUR SERVICES
          </p>
          <p className="mt-4 text-lg/8 text-gray-500">
            We are committed to being the Wilmington area's one-stop shop for all
            things roofing. With years of experience under our belts, there’s no
            job too big or small for the HighTide Roofing team.
          </p>
        </div>

        <div className="mt-11 grid grid-cols-1 items-start gap-x-6 gap-y-16 sm:mt-16 sm:grid-cols-2 lg:grid-cols-4 lg:gap-x-8">
          {features.map((feature) => (
            <div
              key={feature.name}
              className="flex flex-col-reverse reveal-card"
            >
              <div className="mt-6">
                <h3 className="font-chakra_petch_sm text-lg font-medium text-gray-900">
                  {feature.name}
                </h3>
                <p className="mt-2 text-sm text-gray-500">
                  {feature.description}
                </p>
              </div>
              <img
                alt={feature.imageAlt}
                src={feature.imageSrc}
                className="aspect-square w-full rounded-lg bg-gray-100 object-cover shadow-xl"
              />
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center gap-x-6 pt-6">
          <HashLink
            to="/services/#ServiceHeader"
            className="rounded-md bg-red-700 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            View Additional Services
          </HashLink>
        </div>
      </div>
    </div>
  );
}
